export const ACTION_TYPE = {
  BACK: 'BACK',
  NEXT: 'NEXT',
  CLOSE: 'CLOSE',
  SHARE: 'SHARE',
  MENU: 'MENU',
  DELETE: 'DELETE',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  SEARCH: 'SEARCH',
  SKIP: 'SKIP',
};
export const ACTION_TO_ICON_NAME = {
  BACK: 'arrow_forward',
  NEXT: 'arrow_back',
  CLOSE: 'close',
  SHARE: 'share',
  MENU: 'menu',
  DELETE: 'delete',
  UPLOAD_IMAGE: 'add_a_photo',
  SEARCH: 'search',
};

export const ACTION_TO_ACTION_TEXT = {
  SKIP: 'דלג',
};

export const ACTIONS = Object.keys(ACTION_TYPE);
